export default __webpack_public_path__ + "static/media/smileThree.b246095b.svg";